// @flow
import { postJson } from 'utils/http';

export type TrackedUserEventName = 'JAZZHR_REFERRAL';

export const utmSourcesToTrack: { [string]: TrackedUserEventName } = {
  'jazzhr-ref': 'JAZZHR_REFERRAL'
};

export type TrackedUserEventPayload = {
  eventName: TrackedUserEventName,
  extraData: Object
};

export const trackUserEvent = (eventInfo: TrackedUserEventPayload) =>
  postJson('/data/tracked-events', eventInfo);
